// extracted by mini-css-extract-plugin
export default {"container":"table_container__F9LKI"};